export const NeetmockFaq = [
    {
        targetId: '1',
        heading: '1. What is Aakash All India NEET Mock Test 2025?',
        subheading: 'Aakash NEET Mock Test 2025 is an online practice test designed to help NEET (UG) 2025 aspirants assess their preparation. It follows the actual NEET exam pattern, covering Physics, Chemistry, and Biology, and provides an All India Rank (AIR) to help students understand their national-level performance.',
        bulletpoints: [],
    },
    {
        targetId: '2',
        heading: '2. Who can participate in the Aakash All India NEET Mock Test 2025?',
        subheading: 'Any NEET 2025 aspirant can register and appear for the mock test. However, current Aakash students (Aakashians) are not eligible for this test.',
        bulletpoints: [],
    },
    {
        targetId: '3',
        heading: '3. How can I register for the NEET Mock Test 2025?',
        subheading: 'Students can register online on neet-mocktest.aakash.ac.in/neet-mock-test. After filling in the required details and completing the registration process, they will receive exam-related communications.',
        bulletpoints: [],
    },
    {
        targetId: '4',
        heading: '4. Will the Aakash All India NEET Mock Test 2025 be Online or Offline?',
        subheading: `The Aakash NEET Mock tests will be conducted offline. Students need to visit the Aakash's centres opted by students during registration.`,
        bulletpoints: [],
    },
    {
        targetId: '5',
        heading: '5. Is there any registration fee for the Aakash All India NEET Mock Test 2025?',
        subheading: 'The fee for NEET Mock Test 2025 is ₹ 200',
        bulletpoints: [],
    },
    {
        targetId: '6',
        heading: "6. What is the exam date and time slot for the Aakash All India NEET Mock Test 2025?",
        subheading: '<strong>Students can refer to the table below to check the complete details on the NEET Mock test schedule:</strong><table style="border:1px solid #ddd;margint-top:30px;"><tr style="border-bottom: 1px solid #ddd;"><td style="padding:10px 4px 10px 10px;border-right: 1px solid #ddd;"><strong>Exam Type</strong></td><td style="padding: 0px 10px 0px 10px;">Mock Test for NEET 2025</td></tr><tr style="border-bottom: 1px solid #ddd;"><td style="padding:10px 4px 10px 10px;border-right: 1px solid #ddd;"><strong>Test Mode</strong></td><td style="padding: 0px 10px 0px 10px;">Offline</td></tr><tr style="border-bottom: 1px solid #ddd;"><td style="padding:10px 4px 10px 10px;border-right: 1px solid #ddd;"><strong>Exam Day</strong></td><td style="padding: 0px 10px 0px 10px;">13, 20 & 27th April 2025</td></tr><tr style="border-bottom: 1px solid #ddd;"><td style="padding:10px 4px 10px 10px;border-right: 1px solid #ddd;"><strong>Exam Timings</strong></td><td style="padding: 0px 10px 0px 10px;">10:00 AM -1:20 PM</td></tr><tr style="border-bottom: 1px solid #ddd;"><td style="padding:10px 4px 10px 10px;border-right: 1px solid #ddd;"><strong>Exam Duration</strong></td><td style="padding: 0px 10px 0px 10px;">3 hrs 20 min</td></tr><tr style="border-bottom: 1px solid #ddd;"><td style="padding:10px 4px 10px 10px;border-right: 1px solid #ddd;"><strong>Exam Fees</strong></td><td style="padding: 0px 10px 0px 10px;">₹ 200</td></tr><tr style="border-bottom: 1px solid #ddd;"><td style="padding:10px 4px 10px 10px;border-right: 1px solid #ddd;"><strong>Last Date/Time for Enrollment</strong></td><td style="padding: 0px 10px 0px 10px;">5 Days before the Exam Date</td></tr><tr style="border-bottom: 1px solid #ddd;"><td style="padding:10px 4px 10px 10px;border-right: 1px solid #ddd;"><strong>Admit Card Release Date</strong></td><td style="padding: 0px 10px 0px 10px;">2 Days before Exam Date</td></tr><tr style="border-bottom: 1px solid #ddd;"><td style="padding:10px 4px 10px 10px;border-right: 1px solid #ddd;"><strong>Result Declaration</strong></td><td style="padding: 0px 10px 0px 10px;">2 Days after Exam Date (tentative)</td></tr></table>',
        bulletpoints: [],
    },
    {
        targetId: '7',
        heading: '7. When will the admit card be released for the Aakash All India NEET Mock Test 2025?',
        subheading: 'Aakash All India NEET Mock Test 2025 Admit Card will be released 2 Days before the Exam Date',
        bulletpoints: [],
    },
    {
        targetId: '8',
        heading: '8. When will the result be declared for the Aakash All India NEET Mock Test 2025?',
        subheading: `The result will be announced 2 days after the exam date (tentative). This information is usually communicated through official announcements, notifications or the Aakash Institute's website.`,
        bulletpoints: [],
    },
    {
        targetId: '9',
        heading: '9. What are the benefits of the Aakash All India NEET Mock Test 2025?',
        subheading: 'Here are some of the benefits of Aakash All India NEET Mock Tests 2025:',
        bulletpoints: [
            {
                point: 'Experience a real NEET-like exam environment.'
            },
            {
                point: 'Get an All India Rank (AIR) to benchmark performance.'
            },
            {
                point: 'Identify strengths and weaknesses in Physics, Chemistry, and Biology.'
            },
            {
                point: 'Receive detailed performance analysis to refine your strategy.'
            },
            {
                point: 'Practice with sample test papers before the final exam.'
            }
        ],
    },
]